<template>
	<div>
		<div
		 class="expect-job-detail expect-area"
		 :class="{'item-error': isError}"
		 @click="showPopup"
		>
			<span
			 class="name-tip"
			 :class="{'title-tip': hasSelected, 'error': isError}"
			>求职区域</span>
			<div class="selected-text">
				<span
				 v-show="hasSelected"
				 class="selected-text"
				>{{selectedText}}</span>
			</div>
		</div>
		<checklist
		 v-model="showPop"
		 v-if="areaInfo.length > 0"
		 :data="areaInfo"
		 :selects="selectedItems"
		 :max="3"
		 title="选择求职区域（可多选）"
		 @on-close="close"
		 @on-confirm="confirm"
		>
		</checklist>
	</div>
</template>
<script>
import { Checklist } from "@58fe/v5";
import * as types from "../../../store/mutation-types";
import { mapGetters } from "vuex";
export default {
	components: {
		Checklist
	},
	data() {
		return {
			showPop: false,
			selectedItems: [], // 选中的职位
			selectedText: "", // 选中职位名字拼接
			selectedIds: "", // 选中职位id拼接
			hasSelected: false,
			isError: false,
			areaList: []
		};
	},

	computed: {
		...mapGetters(["areaInfo", "sessionAreaList", "pagetypeLog"])
	},
	watch: {
		selectedItems(val) {
			if (val.length > 0) {
				this.hasSelected = true;
			}
		},
		sessionAreaList() {
			this.init();
		}
	},
	created() {
		// 初始化选中项
		this.init();
	},
	methods: {
		init() {
			// 初始化选中项
			let initList = this.sessionAreaList;

			if (initList && initList.length > 0) {
				this.selectedItems.push(initList);
				this.confirm(initList);
			}
		},

		showPopup() {
			this.showPop = true;
			window.clickLog &&
				window.clickLog("from=jl_targetareaclick" + this.pagetypeLog);
		},
		close() {
			window.clickLog &&
				window.clickLog(
					"from=jl_targetareaclick_close" + this.pagetypeLog
				);
			this.showPop = false;
		},
		confirm(val) {
			let selectState = val.length > 0;
			window.clickLog &&
				window.clickLog(
					"from=jl_targetareaclick_confirm" + this.pagetypeLog
				);

			this.selectedItems = val;
			this.selectedText = "";
			this.selectedIds = "";
			val.forEach((item, i) => {
				if (i > 0) {
					this.selectedText += "/";
					this.selectedIds += ",";
				}
				this.selectedText += item.name;
				this.selectedIds += item.id;
			});

			this.showPop = false;
			this.isError = !selectState;

			//  检查是否已填写完整所有必填项
			this.$store.commit(types.CHECK_EXPECTIONINFO, {
				key: "targetAreaId",
				value: this.selectedIds,
				state: selectState
			});
		},
		checkNull() {
			this.isError = true;
			window.clickLog &&
				window.clickLog("from=jl_targetareamiss" + this.pagetypeLog);
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.expect-area {
	border: 0;
}
.selected-text {
	height: px2rem(52px);
	overflow: hidden;
	text-overflow: ellipsis;
	span {
		white-space: nowrap;
	}
}
</style>



// WEBPACK FOOTER //
// areaIntention.vue?74eb369c